module.exports = __webpack_public_path__ + "6a675ab122aede71d1c2a4e48ddd003f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/sweater-s.png
// module id = 1393
// module chunks = 0